import { useEscriptOnboardingContext } from '@/context/escript/EscriptOnboardingProvider';
import { DuplicateTokenExistingAccount } from './States/DuplicateTokenExistingAccount';
import { DuplicateTokenPendingInvite } from './States/DuplicateTokenPendingInvite';
import { InvalidTokenPendingInvite } from './States/InvalidTokenPendingInvite';
import { ScriptAwaitingReview } from './States/ScriptAwaitingReview';
import { ScriptUnsupported } from './States/ScriptUnsupported';
import { ScriptValid } from './States/ScriptValid';
import { ScriptValidOOS } from './States/ScriptValidOOS';
import { SubmitToken } from './States/SubmitToken';

export const EscriptOnboardingFlowContainer = () => {
  const { onboardingState } = useEscriptOnboardingContext();

  const OnboardingStates = {
    SUBMIT_TOKEN: SubmitToken,
    SCRIPT_VALID: ScriptValid,
    SCRIPT_VALID_OUT_OF_STOCK: ScriptValidOOS,
    SCRIPT_UNSUPPORTED: ScriptUnsupported,
    SCRIPT_AWAITING_REVIEW: ScriptAwaitingReview,
    INVALID_TOKEN_PENDING_INVITE: InvalidTokenPendingInvite,
    DUPLICATE_TOKEN_EXISTING_ACCOUNT: DuplicateTokenExistingAccount,
    DUPLICATE_TOKEN_PENDING_INVITE: DuplicateTokenPendingInvite,
  };

  const ActiveComponent = OnboardingStates[onboardingState];
  return <ActiveComponent />;
};
